<template>
    <Multiselect
        class="ostende-select"
        :id="id"
        :value="transformedValue"
        :options="fields"
        label="label"
        placeholder="tous les champs artistiques"
        multiple
        track-by="id"
        :searchable="false"
        :close-on-select="false"
        :show-pointer="showPointer"
        @input="handleChanged"
        @open="handleMultiselectOpened"
        @keydown.self.down.native="handleArrowDownPressed"
        ref="multiselect"
    >
        <template v-slot:tag="{ option }">
            <span class="ostende-select__tag text-nowrap">{{ option.name }}</span>
        </template>
        <template v-slot:option="{ option }">
            <div class="ostende-select__option">
                <b-form-checkbox :checked="isSelected(option)">
                    {{ option.name }}
                </b-form-checkbox>
            </div>
        </template>
        <template v-slot:afterList>
            <div class="text-right mt-2 px-2">
                <button class="btn btn-primary btn-sm" @click="handleOkClicked">Ok</button>
            </div>
        </template>
    </Multiselect>
</template>

<script>
    import { BFormCheckbox } from 'bootstrap-vue';
    import Multiselect from 'vue-multiselect';

    export default {
        components: {
            Multiselect,
            BFormCheckbox,
        },
        props: {
            id: String,
            value: Array,
            fields: Array,
        },
        data() {
            return {
                showPointer: false,
            }
        },
        computed: {
            transformedValue() {
                return (this.value || []).map(id =>
                    this.fields.find(option => option.id === id)
                );
            },
        },
        methods: {
            handleChanged(selectedOptions) {
                this.$emit('change', selectedOptions.map(option => option.id));
            },
            handleMultiselectOpened() {
                this.showPointer = false;
                this.$refs.multiselect.pointer = -1;
            },
            handleOkClicked() {
                this.$refs.multiselect.deactivate();
            },
            handleArrowDownPressed() {
                this.showPointer = true;
            },
            isSelected(option) {
                return (this.value || []).includes(option.id);
            }
        }
    }
</script>